'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Tooltip = require('../../shared/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _hudlUniformUiComponents = require('hudl-uniform-ui-components');

var _icon = require('../../shared/styles/icon.css');

var _g11n = require('../../shared/g11n');

var _g11n2 = _interopRequireDefault(_g11n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var noop = function noop() {};
var mouseDownHandlers = void 0;

window.addEventListener('mouseup', function () {
  if (!mouseDownHandlers) return;
  mouseDownHandlers();
  mouseDownHandlers = undefined;
});

function getProp(prop) {
  var propResult = void 0;

  if (typeof prop === 'function') {
    propResult = prop();
  } else {
    propResult = prop;
  }

  return propResult;
}

function FuncOr(propType) {
  return _propTypes2.default.oneOfType([_propTypes2.default.func, propType]);
}

var GenericComponent = function (_Component) {
  _inherits(GenericComponent, _Component);

  function GenericComponent(props, context) {
    _classCallCheck(this, GenericComponent);

    var _this = _possibleConstructorReturn(this, (GenericComponent.__proto__ || Object.getPrototypeOf(GenericComponent)).call(this, props, context));

    _this.displayName = props.title;
    _this.state = { title: (0, _g11n2.default)(props.title), naturalTitle: props.title };
    return _this;
  }

  _createClass(GenericComponent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.title !== this.state.naturalTitle) {
        this.setState({
          title: (0, _g11n2.default)(nextProps.title),
          naturalTitle: nextProps.title
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (getProp(this.props.isHidden)) {
        return _react2.default.createElement('div', { style: { display: 'none' } });
      }

      var isInactive = getProp(this.props.isInactive);
      var title = this.state.title;

      var className = _icon.iconStyle;
      if (isInactive) {
        className += ' ' + _icon.iconStyleInactive;
      }

      if (this.props.className) {
        className += ' ' + this.props.className;
      }

      var component = _react2.default.createElement(
        'div',
        {
          className: className,
          'data-hudl-element': this.props.dataHudlElement,
          onClick: function onClick() {
            return !isInactive ? _this2.props.onClick(_this2) : noop();
          },
          onMouseDown: function onMouseDown() {
            if (!isInactive && _this2.props.onMouseDown !== noop) {
              _this2.props.onMouseDown(_this2);

              if (_this2.props.onMouseUp !== noop) {
                mouseDownHandlers = _this2.props.onMouseUp.bind(null, _this2);
              }
            }
          }
        },
        _react2.default.createElement(_hudlUniformUiComponents.Icon, { type: this.props.iconName, size: 'medium' })
      );

      if (!title) {
        return component;
      }

      // only wraps in a tooltip if the props.title is provided
      return _react2.default.createElement(
        _Tooltip2.default,
        { title: title },
        component
      );
    }
  }]);

  return GenericComponent;
}(_react.Component);

GenericComponent.propTypes = {
  isHidden: FuncOr(_propTypes2.default.bool),
  isInactive: FuncOr(_propTypes2.default.bool),
  iconName: _propTypes2.default.string.isRequired,
  dataHudlElement: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func
};
GenericComponent.contextTypes = {
  store: _propTypes2.default.object.isRequired
};
GenericComponent.defaultProps = {
  onClick: noop,
  onMouseDown: noop,
  onMouseUp: noop,
  isInactive: noop,
  isHidden: noop
};
exports.default = GenericComponent;
module.exports = exports['default'];